import { NgOptimizedImage, NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { RouterLink } from "@angular/router";
import type { Category } from "@ophardt/shopware-api";
import { SmallestThumbnailPipe } from "@shared/pipes/smallest-thumbnail.pipe";

@Component({
  selector: "app-category-menu-groups",
  templateUrl: "./category-menu-groups.component.html",
  styleUrl: "./category-menu-groups.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, NgTemplateOutlet, RouterLink, SmallestThumbnailPipe],
})
export class CategoryMenuGroupsComponent {
  readonly groups = input.required<Category[]>();
  readonly navigated = output<void>();
}
